export default (value, $t) => {
  const { adults, children } = value
  if (adults === 1) {
    if (children === 0) {
      return $t('ADULT_NUMBER_LABEL')
    } else if (children === 1) {
      return `${$t('ADULT_NUMBER_LABEL')} | ${$t('CHILD_NUMBER_LABEL')}`
    }
    return `${$t('ADULT_NUMBER_LABEL')} | ${$t('CHILDREN_NUMBER_LABEL', { number: children })}`
  } else if (adults > 1) {
    if (children === 0) {
      return $t('ADULTS_NUMBER_LABEL', { number: adults })
    } else if (children === 1) {
      return `${$t('ADULTS_NUMBER_LABEL', { number: adults })}, ${$t('CHILD_NUMBER_LABEL')}`
    }
    return `${$t('ADULTS_NUMBER_LABEL', { number: adults })}, ${$t('CHILDREN_NUMBER_LABEL', { number: children })}`
  }
  return $t('STAY_GUESTS_HEADER')
}
